export default "__VITE_ASSET__QYEn7aHW__"